var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 45,
    viewBox: "0 0 51 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.5934 10.9263L26.6857 10.9539L26.6909 10.9479C27.026 10.9974 27.3535 10.7939 27.452 10.4614C28.3122 7.57109 31.0224 5.5517 34.0418 5.5517C34.4229 5.5517 34.7321 5.24255 34.7321 4.86137C34.7321 4.48019 34.4229 4.17104 34.0418 4.17104C30.2918 4.17104 27.1407 6.6678 26.1289 10.0679C26.0199 10.4334 26.2282 10.8174 26.5934 10.9263Z",
    fill: "white",
    stroke: "#F9FFF9",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.6052 31.3372H38.3633C38.0649 31.3372 37.8229 31.0953 37.8229 30.7969C37.8229 30.4986 38.0649 30.2566 38.3633 30.2566H41.6052C46.074 30.2566 49.71 26.6206 49.71 22.1518C49.71 17.6829 46.074 14.0469 41.6052 14.0469H41.5272C41.3705 14.0469 41.2215 13.979 41.1189 13.8605C41.0162 13.742 40.9699 13.585 40.9923 13.4298C41.0405 13.0933 41.0648 12.7552 41.0648 12.426C41.0648 8.55304 37.9136 5.40175 34.0406 5.40175C32.5339 5.40175 31.097 5.8726 29.8851 6.76373C29.6188 6.95941 29.2406 6.87257 29.0866 6.57964C25.6544 0.0440829 16.6899 -0.833575 12.0423 4.85179C10.0844 7.24694 9.31513 10.3627 9.93155 13.3993C9.99948 13.7347 9.74282 14.0473 9.40203 14.0473H9.18552C4.71671 14.0473 1.0807 17.6834 1.0807 22.1522C1.0807 26.621 4.71671 30.257 9.18552 30.257H12.4274C12.7257 30.257 12.9677 30.499 12.9677 30.7973C12.9677 31.0957 12.7258 31.3377 12.4274 31.3377H9.18552C4.12073 31.3377 0 27.2169 0 22.1521C0 17.2294 3.8926 13.1986 8.76136 12.9763C8.30402 9.8258 9.17857 6.64793 11.2055 4.1679C16.1815 -1.91959 25.7176 -1.23726 29.7487 5.55073C31.0347 4.74449 32.5062 4.32154 34.0404 4.32154C38.7327 4.32154 42.451 8.31531 42.1256 12.9813C46.9495 13.2519 50.7904 17.2614 50.7904 22.1517C50.7904 27.2169 46.6697 31.3373 41.6049 31.3373L41.6052 31.3372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6645 30.4918C11.6645 38.0232 17.7914 44.1501 25.3227 44.1501C32.854 44.1501 38.9809 38.0231 38.9809 30.4918C38.9809 22.9605 32.854 16.8336 25.3227 16.8336C17.7913 16.8336 11.6645 22.9606 11.6645 30.4918ZM13.0453 30.4918C13.0453 23.7224 18.5531 18.2145 25.3227 18.2145C32.0921 18.2145 37.6 23.7223 37.6 30.4918C37.6 37.2613 32.0921 42.7692 25.3227 42.7692C18.5532 42.7692 13.0453 37.2614 13.0453 30.4918Z",
    fill: "white",
    stroke: "#F9FFF9",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.0238 35.9297C25.0238 36.231 25.2682 36.4753 25.5694 36.4753C25.8706 36.4753 26.115 36.2313 26.115 35.9297V25.6446C26.115 25.3433 25.8707 25.099 25.5694 25.099C25.2681 25.099 25.0238 25.3433 25.0238 25.6446V35.9297Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.57 26.4172L22.7913 29.1959L22.7912 29.196L25.57 26.4172ZM25.57 26.4172L28.3488 29.196C28.4552 29.3024 28.5953 29.3558 28.7346 29.3558L25.57 26.4172ZM25.9558 25.2599C25.7427 25.0468 25.3971 25.0466 25.1842 25.2599L28.7346 29.3558C28.8736 29.3558 29.0139 29.3029 29.1205 29.1959C29.3335 28.9828 29.3335 28.6375 29.1204 28.4244L25.9558 25.2599Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.b15fa5ff4e1555f20d53e1dbd80ec9c1.svg";
export { ForwardRef as ReactComponent };